import { useAuth } from '../lib/auth.tsx'
import { IconAlert, IconGoogle } from '../components/icons.tsx'
import { Spinner } from '../components/ui.tsx'

export function SignIn() {
  const { signIn, busy, error } = useAuth()

  return (
    <div className="signin">
      <div className="panel">
        <div className="mark">RP</div>
        <h1>Rajasthan Pharmacia</h1>
        <p className="tag">Patient records &amp; register</p>
        <p className="est">Established 1961 &middot; Jodhpur</p>

        <div className="actions">
          <button className="gbtn" onClick={signIn} disabled={busy}>
            {busy ? <Spinner /> : <IconGoogle />}
            <span>{busy ? 'Opening Google…' : 'Sign in with Google'}</span>
          </button>
        </div>

        {error ? (
          <div className="notice" role="alert">
            <span style={{ color: 'var(--danger)', marginTop: 1 }}><IconAlert size={15} /></span>
            <span>{error}</span>
          </div>
        ) : null}

        <p className="foot">
          Access is limited to registered staff accounts.
          <br />
          Ask the proprietor to add you before signing in.
        </p>
      </div>
    </div>
  )
}
